import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'thousandSuffix' })
export class ThousandSuffixPipe implements PipeTransform {
  transform(value: string): any {
    let exp, suffixes = ['K', 'M', 'G', 'T', 'P', 'E'];
    let decimals = 1;

    if (isNaN(parseFloat(value))) {
      return null;
    }
    else {
      let val = parseFloat(value)

      if (val < 1000) {
        return val;
      }

      exp = Math.floor(Math.log(val) / Math.log(1000));

      return (val / Math.pow(1000, exp)).toFixed(decimals) + suffixes[exp - 1];
    }
  }
}

@Pipe({ name: 'secondsToTime' })
export class SecondsToTimePipe implements PipeTransform {
  transform(value: any): any {
    if (/^\d+$/.test(value)) {
      let date = new Date(null);
      date.setSeconds(value);
      value = date.toISOString().substr(11, 8);
    }
    return value;
  }
}


// WEBPACK FOOTER //
// ./src/app/pages/shared/pipes/thousand-suffix.pipe.ts